import React, { useEffect, useState } from "react";
import { X, BellPlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import * as api from "../api";
import { MEMO_TIPI, isoGiorno } from "./MemoGiorno";

const domani = () => { const d = new Date(); d.setDate(d.getDate() + 1); return isoGiorno(d); };

// "Ricordamelo" dal dettaglio email: memo precompilato con mittente e oggetto
export default function MemoRapidoModal({ email, onClose, onSaved }) {
  const [tipo, setTipo] = useState("mail");
  const [data, setData] = useState(domani());
  const [ora, setOra] = useState("09:00");
  const [testo, setTesto] = useState(email ? `Rispondere a ${email.mittente}: ${email.oggetto}` : "");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (email) { setTesto(`Rispondere a ${email.mittente}: ${email.oggetto}`); setTipo("mail"); setData(domani()); setOra("09:00"); }
  }, [email]);
  if (!email) return null;

  const salva = async () => {
    if (!testo.trim()) return toast.error("Scrivi il testo del memo");
    setBusy(true);
    try {
      await api.addMemo({ data, tipo, testo: testo.trim(), ora, account_id: email.account || "", email_id: email.id || "", email_oggetto: email.oggetto || "" });
      toast.success(`Memo salvato per il ${data.split("-").reverse().join("/")}${ora ? " alle " + ora : ""}`);
      onSaved?.();
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Salvataggio non riuscito");
    } finally { setBusy(false); }
  };

  return (
    <div className="wf-modal-backdrop show" onClick={onClose}>
      <div className="wf-modal modal-leggero" onClick={(e) => e.stopPropagation()} data-testid="memo-rapido-modal">
        <div className="wf-modal-head">
          <span className="wf-modal-title"><BellPlus size={19} strokeWidth={2.4} /> Ricordamelo</span>
          <button className="icon-btn" onClick={onClose} aria-label="Chiudi" data-testid="memo-rapido-close"><X size={20} strokeWidth={2.6} /></button>
        </div>
        <div className="memo-form">
          <div className="proto-row">
            {MEMO_TIPI.map(([t, l, Icon]) => (
              <button key={t} type="button" className={`wf-btn proto-btn ${tipo === t ? "primary" : ""}`} onClick={() => setTipo(t)} data-testid={`memo-rapido-tipo-${t}`}><Icon size={14} /> {l}</button>
            ))}
          </div>
          <div className="host-port">
            <input className="wf-input" type="date" min={isoGiorno(new Date())} value={data} onChange={(e) => setData(e.target.value)} data-testid="memo-rapido-data" />
            <input className="wf-input" type="time" value={ora} onChange={(e) => setOra(e.target.value)} data-testid="memo-rapido-ora" />
          </div>
          <textarea className="wf-input" rows={3} value={testo} onChange={(e) => setTesto(e.target.value)} data-testid="memo-rapido-testo" />
          <div className="manu-text">Mittente: {email.mittente} · {email.email}</div>
          <div className="wf-modal-actions">
            <button className="wf-btn primary" onClick={salva} disabled={busy} data-testid="memo-rapido-save">
              {busy ? <Loader2 size={16} className="spin-icon" /> : <BellPlus size={16} />} Salva memo
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
